import { render } from "./DiseaseBurdenInPH1Oxalosis.vue?vue&type=template&id=75745e6c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__